import React, { useState } from 'react';
import './ExtendLicenseModal.css';

const ExtendLicenseModal = ({ license, onExtend, onCancel, showAlert }) => {
  const [additionalDays, setAdditionalDays] = useState(365);
  const [submitting, setSubmitting] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setSubmitting(true);
    try {
      await onExtend(additionalDays);
    } catch (error) {
      showAlert(`Error: ${error.message}`, 'error');
    } finally {
      setSubmitting(false);
    }
  };

  return (
    <div className="extend-overlay" onClick={onCancel}>
      <div className="extend-modal" onClick={(e) => e.stopPropagation()}>
        <div className="extend-header">
          <h2>⏰ Extend License</h2>
          <button onClick={onCancel} className="extend-close">
            &times;
          </button>
        </div>

        <form onSubmit={handleSubmit} className="extend-form">
          <div className="extend-info">
            <div><strong>Client:</strong> {license.client_name}</div>
            <div><strong>License Key:</strong> <code>{license.license_key}</code></div>
            <div><strong>Current Status:</strong> <span className="extend-status-expired">Expired</span></div>
            {license.expires_at && (
              <div><strong>Expired On:</strong> {new Date(license.expires_at).toLocaleDateString()}</div>
            )}
          </div>

          <div className="extend-field">
            <label className="extend-label">Extend by (Days)</label>
            <input
              type="number"
              value={additionalDays}
              onChange={(e) => setAdditionalDays(parseInt(e.target.value))}
              min="1"
              max="3650"
              className="extend-input"
            />
            <small className="extend-hint">
              New expiry date will be: {new Date(Date.now() + additionalDays * 24 * 60 * 60 * 1000).toLocaleDateString()}
            </small>
          </div>

          <div className="extend-actions">
            <button
              type="button"
              onClick={onCancel}
              disabled={submitting}
              className="extend-btn-cancel"
            >
              Cancel
            </button>
            <button
              type="submit"
              disabled={submitting}
              className="extend-btn-submit"
            >
              {submitting ? '⏳ Extending...' : '✅ Extend License'}
            </button>
          </div>
        </form>
      </div>
    </div>
  );
};

export default ExtendLicenseModal;